import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getInvoicePaymentCustomer, GetInvoicePaymentCustomerParameter } from "@store/Services/InvoicePaymentService";
import { InvoicePaymentCustomerModel } from "@store/Types/InvoicePayment";

type Parameter = GetInvoicePaymentCustomerParameter & HasOnSuccess<InvoicePaymentCustomerModel> & HasOnError<any>;
type Props = {
    error?: any;
};
type HandlerType = ApiHandler<Parameter, InvoicePaymentCustomerModel, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...parameter } = props.parameter;
    props.apiParameter = parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getInvoicePaymentCustomer(props.apiParameter);
    } catch (error) {
        props.error = error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const loadInvoicePayment = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadInvoicePayment");
export default loadInvoicePayment;
